"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
const emotion_0_svg_1 = __importDefault(require("./emotion_0.svg"));
const emotion_1_svg_1 = __importDefault(require("./emotion_1.svg"));
const emotion_2_svg_1 = __importDefault(require("./emotion_2.svg"));
const emotion_3_svg_1 = __importDefault(require("./emotion_3.svg"));
const emotion_4_svg_1 = __importDefault(require("./emotion_4.svg"));
const star_white_svg_1 = __importDefault(require("./star_white.svg"));
const star_black_svg_1 = __importDefault(require("./star_black.svg"));
exports.default = (0, react_1.css) `
    .app_theme_video {
        .app__body {
            display: table-row;
            height: 100%;
        }

        .page {
            padding-top: 0;
            padding-inline-end: var(--page-paddingright);
            padding-bottom: var(--page-paddingbottom);
            padding-inline-start:var(--page-paddingleft);
        }
        & .page__button {
            position: absolute;
            bottom: 0;
            right: var(--page-paddingright);
            left: 51%;
            height: auto;
            margin: 0;
        }

        .question_theme_video .question__content-wrapper_side-align_yes {
            padding-inline-start:1%;
        }

        .question__content-wrapper_side-align_yes .choice__option {
            width: auto !important;
            min-width: 100% !important;
        }
        .question_sideimage_yes .scale .special-options-as-buttons__button .choice__option,
        .question__content-wrapper_side-align_no .scale .special-options-as-buttons__button .choice__option {
            width: auto !important;
            min-width: 46% !important;
        }

        .paginator {
            padding: calc(0.2 * var(--rem)) calc(0.3 * var(--rem)) calc(0.3 * var(--rem));
            box-sizing: border-box;
            text-align: start;
        }

        .markdown * {
            color: #f6f5f3 !important;
        }

        .attachment_type_image img,
        .markdown img {
            max-height: calc((var(--vh) - var(--app-paddingbtm) - var(--app-paddingtop)) / 2);
        }

        /* делаем один размер для любого текста, ограничиваем мин/макс размеры */
        .markdown h1,
        .markdown h2,
        .markdown h3,
        .markdown h4,
        .markdown h5,
        .markdown p {
            font-size: 2em;
            font-size: max(var(--min-header-fontsize), 2em);
        }

        .question_sideimage_yes .question__content-wrapper_side-align_yes .markdown h1,
        .question_sideimage_yes .question__content-wrapper_side-align_yes .markdown h2,
        .question_sideimage_yes .question__content-wrapper_side-align_yes .markdown h3,
        .question_sideimage_yes .question__content-wrapper_side-align_yes .markdown h4,
        .question_sideimage_yes .question__content-wrapper_side-align_yes .markdown h5,
        .question_sideimage_yes .question__content-wrapper_side-align_yes .markdown p {
            font-size: 2em;
            font-size: max(var(--min-header-side-fontsize), 2em);
        }

        .final {
            color: #f6f5f3;
        }

        .special-options-as-buttons__button {
            text-align: start;
        }
        .special-options-as-buttons__button .choice__option {
            white-space: nowrap;
        }
        .scale__option-label {
            font-size: 2em;
            font-size: max(11px, 2em);
        }
        & .scale__option .scale__contatiner {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .scale__labels {
            font-size: calc(0.15 * var(--rem));
        }

        /* rating */
        .rating__container {
            width: 100%;
        }
        .rating__option {
            transition: 0.2s background-color;
            background-image: url(${star_white_svg_1.default});
            background-color: rgba(256, 256, 256, 0.08);
            border-radius: 3px;
            background-size: 60% 60%;
            width: 80%;
        }
        .rating__option.checked,
        .rating__option.checked ~ .rating__option {
            background-image: url(${star_black_svg_1.default});
            background-color: white;
        }

        /* emotion */
        .emotion {
            display: block !important;
        }

        .emotion__options {
            white-space: nowrap;
            display: flex;
            justify-content: stretch;
        }
        .emotion__container {
            flex-grow: 1;
            width: 18%;
        }
        .emotion__container + .emotion__container {
            margin-inline-start: 2%;
        }
        .emotion__option {
            width: 100% !important;
            transition: 0.2s background;
            background-color: rgba(255, 255, 255, 0.1);
            background-repeat: no-repeat;
            border-radius: 3px;
            background-size: 80% 70% !important;
        }
        .emotion__container_checked .emotion__option {
            background-color: white;
        }
        .emotion__option_angry,
        .emotion__container_checked .emotion__option_angry {
            background-image: url(${emotion_0_svg_1.default});
        }
        .emotion__option_sad,
        .emotion__container_checked .emotion__option_sad {
            background-image: url(${emotion_1_svg_1.default});
        }
        .emotion__option_neutral,
        .emotion__container_checked .emotion__option_neutral {
            background-image: url(${emotion_2_svg_1.default});
        }
        .emotion__option_smile,
        .emotion__container_checked .emotion__option_smile {
            background-image: url(${emotion_3_svg_1.default});
        }
        .emotion__option_laugh,
        .emotion__container_checked .emotion__option_laugh {
            background-image: url(${emotion_4_svg_1.default});
        }

        /* choice */
        .choice {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        .question .choice__option {
            transition: 0.2s background;
            width: 49%;
        }

        &.app_orient_vert {
            .choice {
                flex-direction: column;
                flex-wrap: nowrap;
            }
            .question .choice__option {
                width: 100%;
            }
        }

        .question_sideimage_yes .question__side-image .markdown,
        .question_sideimage_yes .question__side-image .attachment {
            max-width: calc(0.4 * var(--vw));
        }

        /* стили как у .attachment-image img */
        .question_sideimage_yes .question__side-image .markdown img {
            margin-bottom: 1.5em;

            display: block;

            max-width: 100%;
            max-height: calc(0.5 * var(--vh, 100vh));
        }

        .question_sideimage_yes.question_type_scale .question__content,
        .question_sideimage_yes.question_type_rating .question__content {
            padding-bottom: calc(0.4 * var(--rem));
        }
        .question_sideimage_yes.question_type_scale .scale,
        .question_sideimage_yes.question_type_rating .rating {
            margin: 0;
            height: calc(1.2 * var(--rem));
        }
        .question_sideimage_yes.question_type_scale .question__content-wrapper .question__label,
        .question_sideimage_yes.question_type_rating .question__content-wrapper .question__label {
            display: block !important;
        }
        .question_sideimage_yes.question_type_scale .question__duplicate-description,
        .question_sideimage_yes.question_type_rating .question__duplicate-description {
            display: none !important;
        }
        .question_sideimage_yes.question_type_rating .rating__wrapper:before {
            padding-top: 50%; /*TODO*/
        }

        .question .choice__option:hover {
            background: rgba(255, 255, 255, 0.3);
        }
        .question .choice__option_checked,
        .question .choice__option_checked:hover {
            background: white;
        }

        .question__duplicate-description {
            display: none;
        }

        /* page */
        /* перебиваем дефолтные стили из-за бага в safari */
        .pages {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .page__button {
            overflow: hidden;
        }
        .page__button-next,
        .page__button-back {
            line-height: var(--next-btn-height);
            height: var(--next-btn-height);
        }
        .page__button-next .y-button__text {
            font-size: var(--next-btn-fontsize);
            line-height: calc(var(--next-btn-height) - 2px);
        }

        .page__questions {
            padding-bottom: calc(var(--next-btn-height) + calc(0.1 * var(--rem)));
        }

        /* размеры 1,2,3,4 */
        &.app_maxHeight-600_yes {
            .scale__options {
                height: 6.4em;
            }
            .scale__label {
                vertical-align: bottom;
            }
            .scale__labels {
                margin-bottom: calc(0.1 * var(--rem));
                font-size: calc(0.2 * var(--rem));
            }
            /* rating */
            .rating__container {
                height: 6.4em;
            }
        }

        /* 1,2,3 */
        &.app_maxHeight-480_yes .paginator {
            display: none;
        }

        /* размер 1 */
        &.app_maxWidth-180_yes,
        &.app_maxHeight-240_yes {
            --next-btn-fontsize: 13px;
            --next-btn-height: 24px;
            --page-paddingright: 1em;
            --page-paddingleft: 1em;
            --min-header-side-fontsize: 11px;

            .markdown {
                font-size: 1.3em;
            }

            .scale {
                margin-top: 0.7em;
            }

            .rating {
                margin-top: 5.8em;
            }

            .emotion {
                margin-top: calc(0.14 * var(--rem)) !important;
            }
            .emotion__option {
                min-width: calc(0.52 * var(--rem));
                height: calc(0.52 * var(--rem));
            }
            .emotion .special-options-as-buttons__button {
                margin-top: 4em !important;
            }

            .choice {
                margin-top: calc(0.12 * var(--rem));
            }
            .question .choice__option-label {
                padding: 1.3em 1em;
            }
            .question__duplicate-description {
                display: block;
            }
            .question_sideimage_yes .question__content-wrapper .question__label {
                display: none;
            }
            .question__content-wrapper .choice {
                margin-top: 0;
            }
            .question .choice__option {
                margin-bottom: 1em;
                margin-inline-end: 0;
            }
            .question .choice__option-control {
                margin-inline-end: 1em;
            }
        }

        &.app_orient_vert.app_maxHeight-360_yes.app_maxHeight-241_yes {
            .scale,
            .rating {
                margin-top: calc(0.38 * var(--rem)) !important;
            }
        }

        /* размер 2 */
        &.app_orient_vert.app_maxHeight-480_yes.app_minHeight-241_yes {
            --next-btn-fontsize: 13px;
            --next-btn-height: 24px;
            --min-header-side-fontsize: 11px;

            .markdown {
                font-size: 1.1em;
            }
            .paginator {
                padding-top: calc(0.12 * var(--rem));
            }
            .special-options-as-buttons__button {
                margin-top: 6em !important;
            }
            .special-options-as-buttons__button .choice__option {
                width: 100%;
            }
            .scale,
            .rating {
                margin-top: calc(0.98 * var(--rem));
            }

            /* emotion */
            .emotion {
                margin-top: calc(1.26 * var(--rem));
            }
            .question_sideimage_no .emotion__option {
                min-width: calc(0.52 * var(--rem));
                min-width: calc(0.16 * var(--vw));
                height: calc(0.52 * var(--rem));
            }
            .question_sideimage_yes .emotion__option {
                min-width: 0;
                height: calc(0.52 * var(--rem));
            }

            /* choice */
            .question .question__label {
                margin-bottom: 2.4em;
            }
            .choice {
                margin-top: calc(0.1 * var(--rem));
            }
            .question .choice__option-label {
                padding: 0.8em 1em;
            }

            /* sideimage */
            .question_sideimage_yes .question__side-image {
                display: block;
                width: 100%;
                margin-bottom: calc(0.1 * var(--rem));
            }
            .question_sideimage_yes .question__content-wrapper {
                width: 100%;
            }
            .question_sideimage_yes .question__content-wrapper .question__label {
                display: none;
            }
            .question_sideimage_yes .question__duplicate-description {
                display: block;
            }
            .question_sideimage_yes .question__content-wrapper_side-align_yes {
                padding-inline-start:0;
            }
            .question_sideimage_yes .question__side-image img {
                margin: 0 auto;
            }
        }

        /* размер 3 */
        &.app_orient_horiz.app_maxHeight-480_yes.app_minHeight-241_yes {
            .markdown {
                font-size: 1.1em;
            }
            .paginator {
                padding-top: calc(0.15 * var(--rem));
            }

            .scale,
            .rating,
            .emotion {
                margin-top: 2.5em;
            }
            .special-options-as-buttons__button {
                margin-top: 2em !important;
            }

            /* emotion */
            .question_sideimage_no .emotion__option {
                min-width: calc(0.82 * var(--rem));
                min-width: calc(0.16 * var(--vw));
                height: calc(0.82 * var(--rem));
            }
            .question_sideimage_yes .emotion__option {
                min-width: 0;
                height: calc(0.82 * var(--rem));
            }

            .emotion .special-options-as-buttons__button {
                margin-top: 2em !important;
            }

            /* choice */
            .question .choice__option-label {
                padding: 0.9em 1em;
            }
            .question__content-wrapper .question__label {
                margin-bottom: 2em;
            }
            .question .choice__option {
                margin-bottom: 1em;
                margin-inline-end: 0;
            }
            .question .choice__option-control {
                margin-inline-end: 1em;
            }

            /* sideimage */
            .question_sideimage_yes .question__duplicate-description {
                display: none;
            }
        }

        /* размер 4 */
        &.app_minHeight-481_yes.app_maxHeight-600_yes,
        &.app_minWidth-481_yes.app_maxWidth-600_yes {
            --next-btn-height: 32px;
            --next-btn-fontsize: 13px;
            --page-paddingleft: 2em;
            --page-paddingright: 2em;
            --min-header-fontsize: 12px;
            --min-header-side-fontsize: 15px;

            .markdown {
                font-size: 1.15em;
            }
            .paginator {
                padding-top: calc(0.13 * var(--rem));
            }

            .special-options-as-buttons__button {
                margin-top: calc(0.2 * var(--rem)) !important;
            }
            .special-options-as-buttons__button .choice__option {
                width: auto;
                display: inline-block;
            }
            .question .special-options-as-buttons__button .choice__option-label {
                padding-inline-end: 4em;
            }

            /* rating */
            .rating__container {
                height: calc(0.48 * var(--rem));
            }

            /* emotion */
            .emotion {
                margin-top: calc(0.36 * var(--rem));
            }
            .question_sideimage_no .emotion__option {
                min-width: calc(0.94 * var(--rem));
                min-width: calc(0.16 * var(--vw));
                height: calc(0.94 * var(--rem));
            }
            .question_sideimage_yes .emotion__option {
                min-width: 0;
                height: calc(0.94 * var(--rem));
            }
            .emotion .special-options-as-buttons__button {
                /*margin-top: 13em !important;*/
                margin-top: 4em !important;
            }

            /* choice */
            .choice {
                margin-top: calc(0.38 * var(--rem));
            }
            .question .choice__option {
                margin-bottom: 1em;
                margin-inline-end: 0;
            }
            .question .choice__option-label {
                padding: 1.3em 1em;
            }
            .question .choice__option-control {
                width: 2.7em;
                height: 2.7em;
                margin-inline-end: 1em;
            }

            /* sideimage */
            .question_sideimage_yes .question__duplicate-description {
                display: block;
            }
            .question_sideimage_yes .question__content-wrapper .question__label {
                display: none;
            }
            .question_sideimage_yes .choice {
                margin-top: 0;
            }
            .question_sideimage_yes .question__content-wrapper {
                padding-inline-start:1%;
                width: 49%;
            }
            .question_sideimage_yes .question__content:after {
                display: inline-block;

                width: 1px;
                height: calc(2 * var(--rem));

                content: '';
                vertical-align: middle;
            }
        }

        /* 5 */
        &.app_minHeight-601_yes.app_minWidth-601_yes {
            --next-btn-fontsize: 16px;
            --next-btn-height: 60px;
            --page-paddingright: 7em;
            --page-paddingleft: 4em;
            --min-header-fontsize: 15px;
            --min-header-side-fontsize: 18px;

            .markdown {
                font-size: 1.5em;
            }

            .scale {
                margin-top: 5em;
            }
            .scale__options {
                height: 6em;
            }
            .special-options-as-buttons__button {
                margin-top: 4em !important;
            }

            /* rating */
            .rating {
                margin-top: 5em;
            }
            .rating__option {
                width: 90%;
            }
            .rating__container {
                height: 6em;
            }
            .rating__wrapper:before {
                padding-top: 0;
            }

            /* emotion */
            .emotion {
                margin-top: 0;
            }
            .emotion__option {
                height: calc(1.02 * var(--rem));
                background-size: 64px;
            }
            .question_sideimage_no .emotion__option {
                min-width: calc(1 * var(--rem));
                min-width: calc(0.15 * var(--vw));
            }
            .question_sideimage_yes .emotion__option {
                min-width: 0;
            }
            .emotion .special-options-as-buttons__button {
                margin-top: 4em !important;
            }

            /* choice */
            .choice {
                margin-top: calc(0.68 * var(--rem));
            }
            .question .choice__option {
                margin-bottom: 1em;
                margin-inline-end: 0;
            }
            .question .choice__option-text {
                font-size: 0.8em;
            }
            .question .choice__option-label {
                padding: 1.5em 2em 1.5em 1.6em;
            }
            .question .choice__option-control {
                width: 3em;
                height: 3em;
                margin-inline-end: 1em;
            }

            /* sideimage */
            .question_sideimage_yes .question__duplicate-description {
                display: block;
            }
            .question_sideimage_yes .question__content-wrapper .question__label {
                display: none;
            }

            .question_sideimage_yes .question__side-image {
                width: 47%;
            }
            .question_sideimage_yes .question__content-wrapper .choice {
                margin-top: 0;
            }
            .question_sideimage_yes .question__content-wrapper {
                padding-inline-start:5%;
                width: 52%;
            }
            .question_sideimage_yes .question__content:after {
                height: calc(3 * var(--rem));
                width: 1px;
                content: '';
                display: inline-block;
                vertical-align: middle;
            }
        }

        /* Из question-choice.css */
        &.app_orient_horiz .choice {
            text-align: start;

            &__option {
                display: inline-block;
                /* width: 45%; ? */
                vertical-align: top;
            }
        }
    }
`;
